import React from "react";
import { Link } from "react-router-dom";

function BillingCancel() {
    return (
        <div className="page">
            <div className="card">
                <h1>Payment canceled</h1>
                <p>No changes were made. You can try again anytime.</p>
                <Link to="/profile">Return to profile</Link>
            </div>
        </div>
    );
}

export default BillingCancel;
